// extracted by mini-css-extract-plugin
export default {"qualityScoreCell":"QualityScoreCell_qualityScoreCell__xsi3J","green":"QualityScoreCell_green__XjMoY","red":"QualityScoreCell_red__mzVZu","orange":"QualityScoreCell_orange__Z1poE"};